module.exports = "//static.hsappstatic.net/LoginUI/static-1.16044/img/ms-logo.png"